<script>
export default {
    name: 'user-info',
    props : ['label', 'info']
}
</script>

<template>
    <div class="row user-info">
        <p class="col-md-3 label">{{ label }}</p>
        <p class="col-md-9 info">{{ info ? info : "Não informado" }}</p>
    </div>
</template>

<style lang="scss">
    .user-info {
        margin-bottom: 6px;
    }

    .label {
        font-size: normal;
    }

    .info {
        font-size: normal;
        color: #14499e;
    }
</style>



// WEBPACK FOOTER //
// src/js/components/profile/p-user-info.vue